module.exports = __webpack_public_path__ + "public/media/5.52db321e.wav";